module.exports = __webpack_public_path__ + "static/media/bg_right.e91ebf20.png";